import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const BASE_URL = process.env.API_URL + '/admin'

const AdminService = {
  actions: {
    fetchAllAdmins ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/admins',
          method: 'GET'
        })
          .then(resp => {
            const admins = resp.data.admins
            commit('api_success')
            resolve(resp)
            return admins
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    createAdmin ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/admin',
          data: data,
          method: 'POST'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    deleteAdmin ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/admin/' + id,
          method: 'delete'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    editAdmin ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/admin/' + data.id,
          data: data,
          method: 'POST'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    fetchAdmin ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/admin/' + id,
          method: 'GET'
        })
          .then(resp => {
            const admin = resp.data.admin
            commit('api_success')
            resolve(resp)
            return admin
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    }
  }
}

export default AdminService



// WEBPACK FOOTER //
// ./src/services/adminService.js